import { eventsEndpoint } from '@/ui/core/config'
import { GuestbookEvent, GuestbookEventSchema } from '@/shared/types'
import { GuestbookClient } from '../GuestbookClient'

export async function listEvents(
  this: GuestbookClient,
): Promise<GuestbookEvent[]> {
  const ownerId = await this.auth.getUser()
  const jwtToken = (await this.auth.getJWT()) ?? ''

  const params = new URLSearchParams({ owner: ownerId }).toString()
  const endpoint = `${eventsEndpoint}?${params}`
  const result = await fetch(endpoint, {
    method: 'GET',
    headers: {
      Authorization: jwtToken,
    },
  })
  // No idea if this works definitely will need to test.
  const events = GuestbookEventSchema.array().parse(await result.json())
  return events
}
